

const addCommas = (nStr) => {
    nStr += '';
    var x = nStr.split('.');
    var x1 = x[0];
    var x2 = x.length > 1 ? '.' + x[1] : '';
    var rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
        x1 = x1.replace(rgx, '$1' + '.' + '$2');
    }
    return x1 + x2;
}


const sortData = (data) => {
    const sortedData = [];
    for (var key in data) {
        sortedData.push(
            { keys: key, value: data[key] }
        );
    }
    const sortedData2 = sortedData.sort((a, b) => (a.value > b.value) ? -1 : 1)
    const newData = {}
    for (var row in sortedData2) {

        newData[sortedData2[row].keys] = sortedData2[row].value
    }

    return newData

}
const sortDataByKey = (data) => {
    const sortedData = [];
    for (var key in data) {
        sortedData.push(
            { keys: key, value: data[key] }
        );
    }
    const sortedData2 = sortedData.sort((a, b) => (a.keys > b.keys) ? 1 : -1)
    const newData = {}
    for (var row in sortedData2) {

        newData[sortedData2[row].keys] = sortedData2[row].value
    }

    return newData

}

const toPercent = (num) => {
    const trf = num.toString().replace('.', ',')
    if (trf.length === 1) {
        return trf + ',0' + '%'
    }
    else {
        return trf + '0' + '%'
    }

}

export { addCommas, sortData, sortDataByKey, toPercent }
